// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.button[data-v-2a5055aa] {

    display: inline-block;

    cursor: pointer;

    border-radius: 12px;

    border-style: solid;

    text-align: center;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.button--brand[data-v-2a5055aa] {

    --tw-border-opacity: 1;

    border-color: rgb(255 183 0 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 183 0 / var(--tw-bg-opacity))
}
.button--brand[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(255 213 141 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 213 141 / var(--tw-bg-opacity))
}
.button--brand[data-v-2a5055aa]:disabled {

    --tw-border-opacity: 1;

    border-color: rgb(255 213 141 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 213 141 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(107 114 128 / var(--tw-text-opacity))
}
.button--brand.noHover[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(255 183 0 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 183 0 / var(--tw-bg-opacity))
}
.button--superdark[data-v-2a5055aa] {

    border-width: 2px;

    --tw-border-opacity: 1;

    border-color: rgb(22 22 22 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(22 22 22 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.button--superdark[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(75 85 99 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(75 85 99 / var(--tw-bg-opacity))
}
.button--superdark[data-v-2a5055aa]:disabled {

    --tw-text-opacity: 1;

    color: rgb(229 231 235 / var(--tw-text-opacity))
}
.button--superdark.noHover[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(22 22 22 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(22 22 22 / var(--tw-bg-opacity))
}
.button--primary[data-v-2a5055aa] {

    --tw-bg-opacity: 1;

    background-color: rgb(16 33 62 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.button--primary[data-v-2a5055aa]:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(71 90 125 / var(--tw-bg-opacity))
}
.button--primary[data-v-2a5055aa]:disabled {

    --tw-text-opacity: 1;

    color: rgb(229 231 235 / var(--tw-text-opacity))
}
.button--primary.noHover[data-v-2a5055aa]:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(16 33 62 / var(--tw-bg-opacity))
}
.button--secondary[data-v-2a5055aa] {

    box-sizing: border-box;

    border-width: 2px;

    --tw-border-opacity: 1;

    border-color: rgb(16 33 62 / var(--tw-border-opacity));

    background-color: transparent;

    --tw-text-opacity: 1;

    color: rgb(16 33 62 / var(--tw-text-opacity))
}
.button--secondary[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(71 90 125 / var(--tw-border-opacity));

    --tw-text-opacity: 1;

    color: rgb(71 90 125 / var(--tw-text-opacity))
}
.button--secondary[data-v-2a5055aa]:disabled {

    --tw-border-opacity: 1;

    border-color: rgb(156 163 175 / var(--tw-border-opacity));

    --tw-text-opacity: 1;

    color: rgb(156 163 175 / var(--tw-text-opacity))
}
.button--secondary.noHover[data-v-2a5055aa]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(16 33 62 / var(--tw-border-opacity));

    --tw-text-opacity: 1;

    color: rgb(16 33 62 / var(--tw-text-opacity))
}
.button--tertiary[data-v-2a5055aa] {

    --tw-bg-opacity: 1;

    background-color: rgb(22 22 22 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(248 248 248 / var(--tw-text-opacity))
}
.button--tertiary[data-v-2a5055aa]:disabled {

    pointer-events: none;

    opacity: 0.5
}
.button--ghost[data-v-2a5055aa] {

    box-sizing: border-box;

    border-color: transparent;

    background-color: transparent;

    --tw-text-opacity: 1;

    color: rgb(16 33 62 / var(--tw-text-opacity))
}
.button--ghost[data-v-2a5055aa]:hover {

    --tw-text-opacity: 1;

    color: rgb(71 90 125 / var(--tw-text-opacity));

    opacity: 0.5
}
.button--ghost.noHover[data-v-2a5055aa]:hover {

    --tw-text-opacity: 1;

    color: rgb(16 33 62 / var(--tw-text-opacity));

    opacity: 1
}
.button--white[data-v-2a5055aa] {

    box-sizing: border-box;

    border-width: 2px;

    --tw-border-opacity: 1;

    border-color: rgb(248 248 248 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(248 248 248 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity))
}
.button--white[data-v-2a5055aa]:hover {

    --tw-text-opacity: 1;

    color: rgb(75 85 99 / var(--tw-text-opacity));

    opacity: 0.5
}
.button--white.noHover[data-v-2a5055aa]:hover {

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    opacity: 1
}
.button--grey[data-v-2a5055aa] {

    box-sizing: border-box;

    border-width: 2px;

    --tw-border-opacity: 1;

    border-color: rgb(255 255 255 / var(--tw-border-opacity));

    background-color: rgb(22 22 22 / var(--tw-bg-opacity));

    --tw-bg-opacity: 0.7;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.button--grey[data-v-2a5055aa]:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(31 41 55 / var(--tw-bg-opacity))
}
.button--grey.noHover[data-v-2a5055aa]:hover {

    --tw-bg-opacity: 1;

    background-color: rgb(22 22 22 / var(--tw-bg-opacity))
}
.button--link[data-v-2a5055aa] {

    --tw-text-opacity: 1;

    color: rgb(72 72 72 / var(--tw-text-opacity));

    text-decoration-line: underline
}
.button--link[data-v-2a5055aa]:hover {

    cursor: pointer
}
.button.rounded[data-v-2a5055aa] {

    border-radius: 2em !important
}
.button.circular[data-v-2a5055aa] {

    min-width: -moz-fit-content !important;

    min-width: fit-content !important;

    border-radius: 100% !important
}
.button--xs[data-v-2a5055aa]:not(.dense) {

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.25rem;

    padding-bottom: 0.25rem;

    font-size: 1rem;

    line-height: 1.5
}
.button--xs.circular[data-v-2a5055aa] {

    padding: 0.5rem
}
.button--sm[data-v-2a5055aa]:not(.dense) {

    min-width: 10rem;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.25rem;

    padding-bottom: 0.25rem;

    font-size: 0.875rem;

    line-height: 1.5
}
.button--sm.circular[data-v-2a5055aa] {

    padding: 0.75rem
}
.button--md[data-v-2a5055aa]:not(.dense) {

    min-width: 10rem;

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-size: 1rem;

    line-height: 1.5
}
.button--md.circular[data-v-2a5055aa] {

    padding: 1rem
}
.button--lg[data-v-2a5055aa]:not(.dense) {

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 1rem;

    padding-bottom: 1rem;

    font-size: 1.125rem;

    line-height: 1.35
}
.button--lg.circular[data-v-2a5055aa] {

    padding: 1.5rem
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/buttons/Button.vue"],"names":[],"mappings":";AAqFA;;IAAA,qBAAA;;IAAA,eAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA,uDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA,uDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,sDAAA;;IAAA,kBAAA;;IAAA,sDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,sDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA,sDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAKA;;IAAA,kBAAA;;IAAA,sDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA,sBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,sDAAA;;IAAA,6BAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,uDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA,sDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,sDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA,yBAAA;;IAAA,6BAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA,8CAAA;;IAAA;AAAA;AAGA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA;AAAA;AAIA;;IAAA,sBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA;AAAA;AAGA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA;AAAA;AAIA;;IAAA,sBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,sDAAA;;IAAA,oBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA;AAAA;AAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA,sCAAA;;IAAA,iCAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,gBAAA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,gBAAA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA","sourcesContent":["<template>\n  <Link v-if=\"tag == 'Link'\" ref=\"button\" class=\"button\" :class=\"[`button--${btnStyle} button--${size}`, { dense }, { rounded }, { circular }, { noHover }]\" :href=\"href\" replace preserve-state @start=\"navigate\">\n    <slot />\n  </Link>\n  <component v-else ref=\"button\" :is=\"tag\" :href=\"href\" class=\"button\" :class=\"[`button--${btnStyle} button--${size}`, { dense }, { rounded }, { circular }, { noHover }]\" @click=\"$emit('click', $event)\">\n    <slot />\n  </component>\n</template>\n\n<script>\nimport { computed, ref } from '@vue/composition-api';\nimport { Link } from '@inertiajs/inertia-vue';\nimport { notifyRoute } from '@/lego/utils/route/notifier';\n\nexport default {\n  components: { Link },\n  props: {\n    btnStyle: {\n      type: String,\n      default: 'primary',\n    },\n\n    size: {\n      type: String,\n      default: 'lg',\n    },\n\n    dense: {\n      type: Boolean,\n      default: false,\n    },\n\n    rounded: {\n      type: Boolean,\n      default: false,\n    },\n\n    circular: {\n      type: Boolean,\n      default: false,\n    },\n\n    tag: {\n      type: String,\n      default: 'button',\n    },\n\n    href: {\n      type: String,\n      default: null,\n    },\n\n    noHover: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  setup(props) {\n    const button = ref(null);\n\n    const click = () => {\n      button.value.click();\n    };\n\n    const prevStepPath = computed(() => {\n      const url = new URL(props.href);\n      return url.pathname + window.location.search;\n    });\n\n    return {\n      button,\n      click,\n      prevStepPath,\n      navigate: () => {\n        if (!!prevStepPath.value) {\n          notifyRoute(prevStepPath.value);\n        }\n      },\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.button {\n  @apply rounded-md style-body-sm inline-block text-center cursor-pointer border-solid;\n\n  &--brand {\n    @apply bg-brand-primary-main border-brand-primary-main hover:bg-brand-primary-soft disabled:bg-brand-primary-soft hover:border-brand-primary-soft disabled:border-brand-primary-soft disabled:text-neutral-semidark;\n\n    &.noHover {\n      @apply hover:bg-brand-primary-main hover:border-brand-primary-main;\n    }\n  }\n  &--superdark {\n    @apply bg-neutral-superdark text-neutral-white border-thin border-neutral-superdark hover:border-neutral-dark hover:bg-neutral-dark disabled:text-neutral-light;\n\n    &.noHover {\n      @apply hover:bg-neutral-superdark hover:border-neutral-superdark;\n    }\n  }\n\n  &--primary {\n    @apply bg-brand-secondary-dark text-neutral-white hover:bg-brand-secondary-lightest disabled:text-neutral-light;\n\n    &.noHover {\n      @apply hover:bg-brand-secondary-dark;\n    }\n  }\n  &--secondary {\n    @apply bg-transparent border-thin text-brand-secondary-dark border-brand-secondary-dark hover:border-brand-secondary-lightest hover:text-brand-secondary-lightest box-border disabled:text-neutral-medium disabled:border-neutral-medium;\n\n    &.noHover {\n      @apply hover:border-brand-secondary-dark hover:text-brand-secondary-dark;\n    }\n  }\n  &--tertiary {\n    @apply bg-neutral-superdark text-neutral-lighter disabled:opacity-50 disabled:pointer-events-none;\n  }\n  &--ghost {\n    @apply bg-transparent text-brand-secondary-dark hover:text-brand-secondary-lightest border-transparent box-border hover:opacity-50;\n\n    &.noHover {\n      @apply hover:text-brand-secondary-dark hover:opacity-100;\n    }\n  }\n  &--white {\n    @apply bg-neutral-lighter text-neutral-ultradark hover:text-neutral-dark border-thin box-border hover:opacity-50 border-neutral-lighter;\n\n    &.noHover {\n      @apply hover:text-neutral-ultradark hover:opacity-100;\n    }\n  }\n  &--grey {\n    @apply bg-neutral-superdark bg-opacity-70 hover:bg-neutral-darkest text-neutral-white border-thin border-neutral-white box-border;\n\n    &.noHover {\n      @apply hover:bg-neutral-superdark;\n    }\n  }\n  &--link {\n    @apply underline hover:cursor-pointer text-neutral-darker;\n  }\n  &.rounded {\n    @apply !rounded-pill;\n  }\n  &.circular {\n    @apply !rounded-circular !min-w-fit;\n  }\n  &--xs {\n    &:not(.dense) {\n      @apply px-xxxs py-quark leading-long text-xs;\n    }\n    &.circular {\n      @apply p-nano;\n    }\n  }\n  &--sm {\n    &:not(.dense) {\n      @apply px-nano py-quark min-w-[10rem] leading-long text-nano;\n    }\n    &.circular {\n      @apply p-micro;\n    }\n  }\n  &--md {\n    &:not(.dense) {\n      @apply px-xxxs py-nano min-w-[10rem] leading-long text-xs;\n    }\n    &.circular {\n      @apply p-xxxs;\n    }\n  }\n  &--lg {\n    &:not(.dense) {\n      @apply px-xxs py-xxxs leading-medium text-sm;\n    }\n    &.circular {\n      @apply p-xxs;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
